import { FEATURES, FeatureFlagKey } from 'appConstants';

type FeatureFlagMap = Partial<Record<FeatureFlagKey, boolean>>;

export const AI_MASTER_FLAG_KEY = FEATURES.PERX_AI_WORKSPACE.key;

export const AI_CHILD_FLAG_KEYS = [
  FEATURES.INTELLIGENCE_SUITE.key,
  FEATURES.AI_ASSISTANT.key,
  FEATURES.LAYER_6_DASHBOARD.key
];

export const EXPERIENCE_STUDIO_FLAG_KEY = FEATURES.EXPERIENCE_STUDIO.key;

export const EXPERIENCE_STUDIO_PREREQUISITE_KEYS = [AI_MASTER_FLAG_KEY, FEATURES.MICROSITE.key];

/** Every flag the master gates, in the order the settings page nests them under the master. */
export const AI_GROUP_CHILD_KEYS = [...AI_CHILD_FLAG_KEYS, EXPERIENCE_STUDIO_FLAG_KEY];

/**
 * Forces every AI child flag off unless the master `perx_ai_workspace` flag is exactly `true`, so a
 * tenant that never received the master row cannot reach an AI surface through a stale child flag.
 * `experience_studio` additionally needs `microsite === true`. Returns the input untouched when
 * nothing needs masking: callers feed the result to `useMemo` deps and a fresh object every render
 * would rebuild the sidebar menu on each pass. PLA-8844, PLA-9688.
 */
export const applyAiMasterFlag = <T extends FeatureFlagMap>(features?: T): T => {
  const flags = (features ?? {}) as T;

  if (flags[AI_MASTER_FLAG_KEY] === true) {
    if (flags[FEATURES.MICROSITE.key] === true || flags[EXPERIENCE_STUDIO_FLAG_KEY] !== true) {
      return flags;
    }

    return { ...flags, [EXPERIENCE_STUDIO_FLAG_KEY]: false };
  }

  return AI_GROUP_CHILD_KEYS.reduce<T>((masked, key) => ({ ...masked, [key]: false }), flags);
};
